<liv-dropdown-menu
  [expanded]="expandFilterDropdown()"
  (expandedChange)="expandFilterDropdown.set($event)"
>
  <liv-dropdown-menu-trigger
    tone="secondary"
    [disabled]="!hasManyAcademicYears()"
    [loading]="isLoadingAcademicYears()"
    [label]="selectedAcademicYear()?.nome || selectedAcademicYear()?.ano"
    [placeholder]="'select_dropdown.placeholder' | translate"
    [loadingText]="'select_dropdown.loading' | translate"
  ></liv-dropdown-menu-trigger>

  @for (academicYear of selectableAcademicYears(); track academicYear.id) {
    <button
      liv-dropdown-menu-item
      type="button"
      (click)="handleSelectAcademicYear(academicYear)"
    >
      {{ academicYear.nome || academicYear.ano }}
    </button>
  }
</liv-dropdown-menu>
